import React from 'react';

export default function InfoElement(props) {
  return (
    <div dangerouslySetInnerHTML={{__html: props.infoHtml}}>
    </div>
  );
}


